// GENERATED by scripts/sync-elevenlabs-v4-voices.mjs on 2026-10-01. Do not edit
// by hand; re-run the script when voices are added or retrained.
//
// Catalog voices that keep their character on Eleven v4: 64 of 1951
// (55 professional clones trained for v4, the rest ElevenLabs premade voices).
// Every other catalog voice stays on the model it used before v4. Voice kinds
// seen: {"professional":1898,"premade":9,"generated":36}. 8 could not be read.
export const ELEVEN_V4_READY_VOICE_IDS: ReadonlySet<string> = new Set([
  '1yebI4wPatIbQgkzinlP',
  '2GJZCZIWrWiGFDntCFaz',
  '2OXYbN1uGomXXJtv9Dq6',
  '4QmRQP2RqsuTD7HT9MkW',
  '6YKajEZO7fjiakslxwff',
  '6dUn0LOxdDTsxwitRcli',
  '6e6TrJGLhrDGMKOy5x2i',
  '8fqGzH80bdkm2UseeV9f',
  '9PvnT6XRzlljoaDG6Knu',
  'AA6iXlJYcLQWoTQnJw8E',
  'EXAVITQu4vr4xnSDxMaL',
  'EaBs7G1VibMrNAuz2Na7',
  'F6apuaOciIF8axVr21FB',
  'FZDpfsjLp5bRzmlwdm0P',
  'FhOnCtjmaAIRIS1Dg2bk',
  'GQrVSQduiFCVTMHGavV5',
  'IKne3meq5aSn9XLyUdCD',
  'MXGyTMlsvQgQ4BL0emIa',
  'Mz4GsCKSPU4BZl2sMASU',
  'N2lVS1w4EtoT3dr4eOWO',
  'NFG5qt843uXKj4pFvR7C',
  'NO5A3b3sSzDyJQF7MiNS',
  'OVkoEbwxsYHiSRMFV9t3',
  'OZxMHsGaBmV5pjMIDIn0',
  'P7vsEyTOpZ6YUTulin8m',
  'QKyvRuehpb8zB3cRkzIn',
  'S3RXi1qdUT4is6DxRHdi',
  'SOYHLrjzK2X1ezoPC6cr',
  'T8lgQl6x5PSdhmmWx42m',
  'TX3LPaxmHKxFdv7VOQHJ',
  'UeUC009F3NYPIArcZmq0',
  'VR6AewLTigWG4xSOukaG',
  'WczBIOau2qV9z7nLeDqq',
  'XrExE9yKIg1WjnnlVkGX',
  'ZRwrL4id6j1HPGFkeCzO',
  'aCChyB4P5WEomwRsOKRh',
  'dCfjdikb3Vzuo3qxhmwc',
  'eh5YJlyB5bmWfcmcEsLN',
  'f4UZfBDD7d4QR1DcXAMf',
  'fJE3lSefh7YI494JMYYz',
  'gCr8TeSJgJaeaIoV4RWH',
  'gqFUMFHCD2nbbcYVtPGB',
  'h5TGSgjuArqhPBRRe0mM',
  'hT1MsRBLaHSXGeWzW6xF',
  'hWHihsTve3RbzG4PHDBQ',
  'hbLdgbgzfKYPCUr4Rs2V',
  'imphBib61OiJ8r9IfSGe',
  'iuABfyf7pRoBzuPqzUCt',
  'kZKm3BYbXfahOLAxYZG0',
  'm7GHBtY0UEqljrKQw2JH',
  'mCQMfsqGDT6IDkEKR20a',
  'nNt0YcINdGadGcTx5fBM',
  'oNRN9HppGQaRc2aCxlG9',
  'onwK4e9ZLuTAKqWW03F9',
  'pNInz6obpgDQGcFmaJgB',
  'q4yUdydpWxqfmkQH7gK7',
  'sXXU5CoXEMsIqocfPUh2',
  'siw1N9V8LmYeEWKyWBxv',
  'uC9VI5XrTxXRNlCzGSKR',
  'vYENaCJHl4vFKNDYPr8y',
  'wytO3xyllSDjJKHNkchr',
  'xMagNCpMgZ83QOEsHNre',
  'zFLlkq72ysbq1TWC0Mlx',
  'zIxDnGtj6IzAkP4KJ2Oo',
]);
